/* eslint-disable @typescript-eslint/naming-convention */
import apiServiceApiGateway from 'config/apiServiceApiGateway'

import {
  GetAllPageIDListResponsesInterface,
  QueryURLPageIDListType,
  CreateUpadatePageIDResponseType,
  PostPageIDRequestType,
  PutPageIDRequestType,
  GetPagePermissionOptionsResponseType,
  GetDetailPageIDResponseType,
  GetJSONPageIDDetailsResponseType,
} from 'features/Account/@types/intoolsAccessPageIDList'

export const getAllPageIDList = async (query: QueryURLPageIDListType) =>
  apiServiceApiGateway.Get<GetAllPageIDListResponsesInterface>({
    url: `/auth/internal/v1/page/intools`,
    params: query,
    config: { headers: { ...{ 'x-external-type': 'intools' } } },
  })

export const getDetailPageIDAPI = async (pageId: string) =>
  apiServiceApiGateway.Get<GetDetailPageIDResponseType>({
    url: `/auth/internal/v1/page/intools/${pageId}`,
    config: { headers: { ...{ 'x-external-type': 'intools' } } },
  })

export const postPageIDAPI = (payload: PostPageIDRequestType) =>
  apiServiceApiGateway.Post<CreateUpadatePageIDResponseType>({
    url: `/auth/internal/v1/page/intools`,
    data: payload,
    config: { headers: { ...{ 'x-external-type': 'intools' } } },
  })

export const putPageIDAPI = ({
  id,
  payload,
  isVendor: _isVendor = false,
}: {
  id: string
  payload: PutPageIDRequestType
  isVendor?: boolean
}) =>
  apiServiceApiGateway.Put<CreateUpadatePageIDResponseType>({
    url: `/auth/internal/v1/page/intools/${id}`,
    data: payload,
    config: { headers: { ...{ 'x-external-type': 'intools' } } },
  })

export const getPagePermissionOptionsAPI = (_isVendor = false) =>
  apiServiceApiGateway.Get<GetPagePermissionOptionsResponseType>({
    url: `/auth/internal/v1/permission/option`,
    config: { headers: { ...{ 'x-external-type': 'intools' } } },
  })

export const getJSONPageIDDetailsAPI = (id: string) =>
  apiServiceApiGateway.Get<GetJSONPageIDDetailsResponseType>({
    url: `/auth/internal/v1/page/intools/json/:id`,
    urlParams: { id },
    config: { headers: { ...{ 'x-external-type': 'intools' } } },
  })

export const postUploadJSONPageDetailsAPI = (data: { page_json: string }) =>
  apiServiceApiGateway.Post<GetJSONPageIDDetailsResponseType>({
    url: `/auth/internal/v1/page/intools/json`,
    data,
    config: { headers: { ...{ 'x-external-type': 'intools' } } },
  })
